import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import RippleLoader from "../../../components/loader/RippleLoader";
import { Form, Formik } from "formik";
import ConfirmationModel from "../../../components/common/ConfirmationModel";
import {
  companiesStaff,
  createOutletStaff,
  getByIdOutlet,
} from "../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import { SelectWithLabel } from "../../../components/micro/input";
import { Chip } from "@mui/material";
import { Cancel } from "@mui/icons-material";

const AddEditStaff = ({ onClose, company, modalData }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  //Selector
  const { staffList } = useSelector((store) => ({
    staffList: store?.companiesData?.companiesStaffStatus?.data,
  }));

  useEffect(() => {
    dispatch(
      companiesStaff({
        search: "",
        roles: "staff",
        pageCount: "",
        pageLimit: "all",
        types: "Outlet",
        outlet: "null",
        company_id: company || "",
        sort_by: "",
        sort_direction: "desc",
      })
    );
  }, []);

  const outletOptions =
    Array.isArray(staffList?.data) && staffList.data.length > 0
      ? [...new Set(staffList.data.map((item) => item?.user))].map(
          (person) => ({
            label: person?.full_name,
            value: person?.id,
          })
        )
      : [
          {
            label: "No staff available",
            value: "",
            disabled: true,
          },
        ];

  const handleFormSubmit = async (values) => {
    const payload = {
      staff_ids: values?.staff?.map((outlet) => outlet.value),
      outlet_id: modalData?.outletData?.id,
    };
    setIsLoading(true);
    try {
      await dispatch(createOutletStaff(payload));
      setIsLoading(false);
      setShowConfirmationModal(false);
      onClose();
      dispatch(getByIdOutlet(modalData?.outletData?.id));
    } catch (error) {
      setIsLoading(false);
      console.error("Error submitting form: ", error);
    }
  };

  const handleDeleteOutlet = (e, value, values, setFieldValue) => {
    e.stopPropagation();

    const updatedOutlets = values?.staff?.filter(
      (outlet) => outlet.value !== value
    );

    setFieldValue("staff", updatedOutlets);
  };

  return (
    <>
      <div className="model" onClick={onClose} style={{ zIndex: 1300 }}>
        <div
          className="bg-white items-center justify-center drop-shadow-lg rounded-lg w-full max-w-xl py-8 px-6 mx-auto relative"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h4 className="font-Montserrat text-xl font-normal">Add Staff</h4>
          {isLoading ? (
            <RippleLoader />
          ) : (
            <Formik
              enableReinitialize={true}
              initialValues={{
                staff: [],
              }}
              validationSchema={Yup.object().shape({
                staff: Yup.array().min(1, "At least one outlet is required"),
              })}
              onSubmit={(values) => {
                setFormValues(values);
                setShowConfirmationModal(true);
              }}
            >
              {({ values, errors, touched, handleSubmit, setFieldValue }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="mb-4 mt-3">
                    <SelectWithLabel
                      idFromName="staff"
                      placeholder="Staff"
                      options={outletOptions}
                      value={values?.staff?.map((option) => option.value) || []}
                      setFieldValue={setFieldValue}
                      multiple
                      errors={errors.staff}
                      touched={touched.staff}
                      onChange={(event) => {
                        const selectedValues = event.target.value;
                        const selectedOptions = outletOptions?.filter(
                          (option) =>
                            selectedValues.includes(option.value) &&
                            !option.disabled
                        );
                        setFieldValue("staff", selectedOptions);
                      }}
                      renderValue={(selected) => (
                        <>
                          {selected.map((value) => {
                            const selectedOption = outletOptions?.find(
                              (option) => option.value === value
                            );
                            return (
                              <Chip
                                key={value}
                                label={selectedOption?.label}
                                sx={{ marginRight: "5px" }}
                                clickable
                                variant="outlined"
                                deleteIcon={
                                  <Cancel
                                    onMouseDown={(event) =>
                                      event.stopPropagation()
                                    }
                                  />
                                }
                                onDelete={(e) =>
                                  handleDeleteOutlet(
                                    e,
                                    value,
                                    values,
                                    setFieldValue
                                  )
                                }
                              />
                            );
                          })}
                        </>
                      )}
                    />
                  </div>

                  {/* Submit button */}
                  <div className="flex justify-end gap-3 mt-3 w-full">
                    <button
                      onClick={onClose}
                      type="button"
                      className=" text-themeBtn w-full flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
                    >
                      <span>Cancel</span>
                    </button>
                    <button
                      type="submit"
                      className="flex items-center w-full justify-center px-6 py-1.5 rounded font-Montserrat uppercase border-2 border-themeBtn  text-white bg-themeBtn"
                      // onClick={onConfirm}
                    >
                      <span>Confirm</span>
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
        {showConfirmationModal && (
          <div>
            <ConfirmationModel
              confirmText={"Create"}
              onClose={() => setShowConfirmationModal(false)}
              onConfirm={() => handleFormSubmit(formValues)}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default AddEditStaff;
